/** SSO from admin-dashboard to pos-web, POS.md §12.9.2: a one-time ticket, 60 s, single use. */

export const SSO_ENDPOINTS = {
  /** Staff: create a ticket. */
  ticket: '/api/backoffice/sso-ticket',
  /** Trade a ticket for a staff token. */
  exchange: '/api/backoffice/sso-exchange',
} as const

/** pos-web reads the ticket from this query parameter. */
export const SSO_QUERY_PARAM = 'sso'

export interface SsoTicket {
  ticket: string
  expires_in: number
}

export interface SsoExchangeResult {
  authorization: { token_type: string; token: string }
}
